$(function() {
    if($('body').hasClass('for-healthcare-professionals')){
        let mainError = false

        $('.acf-form-fields').animate({height: $('.form-section-1').height()}, function(){ $('.acf-form-fields, .button-container').addClass('active') })

        function emailNPI(data) {
            let info = data.data,
                npi_data = ''

            npi_data = npi_data + 'First Name: ' + info.profile.first_name +  '<br>'
            npi_data = npi_data + 'Last Name: ' + info.profile.last_name + '<br>'
            npi_data = npi_data + 'Number: ' + info.npi + '<br>'

            // Specialty Info
            if(info.specialties){
                let length = info.specialties.length -1

                npi_data = npi_data + '<br> Specialty: '

                // Comma Separate Specialties
                $.each(info.specialties, function(i){
                    npi_data = npi_data + this.name + (i == length ? '<br><br>' : ', ')
                })
            }

            // Practice Info
            if(info.practices){
                $.each(info.practices, function(i){
                    let address = this.visit_address,
                        number

                    npi_data = npi_data + 'Practice Name: ' + this.name + '<br>'
                    npi_data = npi_data + 'Address 1: ' + address.street + '<br>'
                    npi_data = npi_data + (address.street2 ? 'Address 2: ' + address.street2 + '<br>' : '')
                    npi_data = npi_data + 'City: ' + address.city + '<br>'
                    npi_data = npi_data + 'State: ' + address.state  + '<br>'
                    npi_data = npi_data + 'Zip: ' + address.zip + '<br>'

                    $.each(this.phones, function(){
                        number = (this.type === 'business_landline' ? this.number : (this.type === 'landline' ? this.number : ''))
                    })

                    if(number !== '') { npi_data = npi_data + 'Phone: ' + number + '<br>' }

                    npi_data = npi_data + '<br>'

                    // Only display two addresses per doctor
                    return i < 1
                })
            }

            return npi_data
        }

        function validateNPI(url, $field) {
            return $.ajax({
                url: url,
                dataType: 'json',
                beforeSend: function(){
                    $field.append('<i class="fas fa-spinner fa-pulse"></i>')
                },
                success: function(){
                    $field.find('i.fas').remove()
                    $field.append('<i class="fas fa-check-circle"></i>')
                },
                error: function(){
                    $field.find('i.fas').remove()
                }
            })
        }

        function validationError($el, message, $acfFields) {
            $el.closest('.acf-field').addClass('acf-error')

            if($el.children('.acf-error-message').length === 0) {
                $el.prepend('<div class="acf-error-message"><p>' + message + '</p></div>').fadeIn()
                $acfFields.animate({height: $acfFields.height() + $el.find('.acf-error-message').outerHeight()})
            }
        }

        function formTop() {
            $('html, body').animate({scrollTop: $('#physician-form').offset().top - $('#sticky-nav').outerHeight(true)}, 500);
        }


        // Close Main Validation Message
        $(document).on('mainError', function(){
            if(!!mainError) {
                $('a.-cancel').on('click', function(e){
                    let $this = $(this)
                    e.preventDefault()
                    $this.parent('.acf-error-message').remove()
                })
            }
        })

        // Validate NPI
        $('[name="acf[field_5aee116607cdd][field_5aee116607e3e]"]').on('blur', function() {
            let $this = $(this),
                $field = $this.closest('.acf-field'),
                $formFields = $this.parents('.acf-form-fields'),
                $hidden = $this.closest('.form-section').siblings('[name="acf[field_5af4c48d784d0]"]'),
                $btn = $this.closest('.acf-form').siblings('.button-container').find('.next'),
                $input = $this.closest('.acf-input'),
                npi = $this.val()

            if(npi === '') {
                if($field.find('i.fas').length > 0){
                    $field.find('i.fas').remove()
                }
                validationError($input, 'NPI is required.', $formFields)
            } else {
                let url = 'https://api.betterdoctor.com/2016-03-01/doctors/npi/' + npi + '?user_key=7145db0dda9b6d9f40b6223e90569588'

                validateNPI(url, $field).then(function (response) {
                    // Input NPI data into hidden field
                    let val = emailNPI(response)
                    $hidden.val(val)
                    $btn.removeClass('disabled').prop('disabled', false)

                }, function (reject) {
                    validationError($input, 'NPI is not valid.', $formFields)
                })
            }
        })

        // Next and Prev Buttons for Progress Bar
        $('.progress-button').on('click', function() {
            let $this = $(this),
                $currentForm = $(this).parents('.button-container').siblings('.acf-form'),
                $section = $currentForm.find('.form-section.active'),
                sections = $currentForm.find('.form-section').length,

                currentID = parseInt($section.attr('id').split('-')[1]),
                nextID = (currentID + 1 > sections) ? currentID : currentID + 1,
                prevID = (currentID - 1 <= 0) ? currentID : currentID - 1,

                $btnContainer =  $this.parent('.button-container'),
                $form = $btnContainer.siblings('.acf-form'),
                $formFields = $form.find('.acf-form-fields'),
                $next = $btnContainer.find('.next'),
                $prev = $btnContainer.find('.prev'),
                $submit = $form.find('.acf-form-submit'),
                $progressBar = $form.siblings('.progress-bar')

            // // Next Button
            if($this.hasClass('next')) {
                let fields = $section.find('.acf-field[data-required="1"]'),
                    validated = true,
                    failed = []

                // Check if required fields have values before proceeding to next step
                $.each(fields, function() {
                    let $this = $(this)

                    // NPI number validation
                    if($this.closest('.acf-hidden').length === 0) {
                        if($this.hasClass('zip-code') && $this.find('input').val() !== '') {
                            let val = $this.find('input').val()
                            if(!$.isNumeric(val)) { failed.push($this) }
                        } else if($this.attr('id') !== 'npi-number' && $this.find('input').val() === '') {
                            failed.push($this)
                        }
                    }
                })

                if(failed.length !== 0) { validated = false }

                // If validated proceed to next section
                if(validated) {
                    $form.children('.acf-error-message').remove()
                    $section.removeClass('active')

                    if(nextID === sections) {
                        $next.hide()
                        $submit.show()
                    }

                    if(nextID >= 2) { $prev.show() } else { $prev.hide() }

                    $formFields.animate({height: $form.find('.form-section-' + nextID).height()})

                    $form.find('.form-section-' + nextID).addClass('active')
                    $progressBar.find('.step-' + nextID).addClass('active')
                    formTop()

                    // Else throw error messages
                } else {
                    let errorHeight = 0,
                        siblingErrors = 0

                    // Only add general error message once otherwise just update number of fields
                    if($('.acf-error-message.main-error').length === 0) {
                        $form.prepend('<div class="acf-error-message main-error"><p>Validation failed. ' + failed.length + ' field' + (failed.length > 1 ? 's' : '') + ' require' + (failed.length > 1 ? '' : 's') + ' attention.</p><a href="#" class="acf-icon -cancel small"></a></div>')
                        mainError = true
                        $(document).trigger('mainError')
                    } else {
                        $form.find('.main-error p').text('Validation failed. ' + failed.length + ' field' + (failed.length > 1 ? 's' : '') + ' require' + (failed.length > 1 ? '' : 's') + ' attention.')
                        mainError = true
                        $(document).trigger('mainError')
                    }

                    $.each(failed, function() {
                        let $this = $(this),
                            label = $this.find('label').text().replace('*', '')

                        // Only add field error message once
                        if($this.find('.acf-input').children('.acf-error-message').length === 0) {
                            $this.addClass('acf-error')
                            $this.find('.acf-input').prepend('<div class="acf-error-message"><p>' + label + ' is required.</p></div>').fadeIn()

                            if($this.hasClass('sized-input') && $this.siblings('.sized-input.acf-error').length > 0) {
                                let sizedInputs = $this.siblings('.sized-input.acf-error')

                                siblingErrors = sizedInputs.length

                                $.each(sizedInputs, function(){
                                    $(this).addClass('skipHeight')
                                })
                            } else {
                                $(this).removeClass('skipHeight')
                            }

                            errorHeight = errorHeight + $this.find('.acf-error-message').outerHeight()
                            return siblingErrors
                        }
                    })

                    // Remove duplicate heights due to inline errors
                    if(siblingErrors !== 0) {
                        console.log(siblingErrors)
                        errorHeight = errorHeight - (siblingErrors * 37)
                    }

                    if(errorHeight > 0) {
                        $formFields.animate({height: $formFields.height() + errorHeight})
                    }

                    formTop()
                }

            // Prev Button
            } else if($this.hasClass('prev')) {
                $form.children('.acf-error-message').remove()
                $section.removeClass('active')

                if(nextID === sections) {
                    $next.show()
                    $submit.hide()
                }

                if(prevID === 1) { $prev.hide() } else { $prev.show() }

                $form.find('.form-section-' + currentID).removeClass('active')
                $progressBar.find('.step-' + currentID).removeClass('active')

                $formFields.animate({height: $form.find('.form-section-' + prevID).height()})

                $form.find('.form-section-' + prevID).addClass('active')
                $progressBar.find('.step-' + prevID).addClass('active')
                formTop()
            }
        })
    }
})